































































































































// @ts-ignore
import v8n from 'v8n';
import moment from 'moment';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { authModule, bookingModule } from '@/store';
import { PromoCode } from '@/api';

@Component({
  components: {},
})
export default class extends Vue {
  bookingError: { detail: string; pointer: string; } | null = null;
  loading: boolean = false;
  promoLoading: boolean = false;

  promoCode: string = '';
  discount: PromoCode | null = null;
  promoSuccess: boolean = false;
  promoError: boolean = false;
  discountError: string = '';

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  get booking() {
    if (!bookingModule.booking) {
      return;
    }
    return bookingModule.booking;
  }

  get startDate() {
    if (!bookingModule.startDate) {
      return;
    }
    return moment(bookingModule.startDate, 'YYYY-MM-DD').format(
      'dddd, D MMMM YYYY',
    );
  }

  get endDate() {
    if (!bookingModule.endDate) {
      return;
    }
    return moment(bookingModule.endDate, 'YYYY-MM-DD').format(
      'dddd, D MMMM YYYY',
    );
  }

  get hasSubscriptionDiscount() {
    if (!this.booking) {
      return false;
    }

    const lotType = this.booking.lot.slug;
    if (lotType === 'indoor') {
      return authModule.activeIndoorSubscription;
    } else if (lotType === 'outdoor') {
      return authModule.activeOutdoorSubscription;
    } else {
      return false;
    }
  }

  get parkingPrice() {
    if (!bookingModule.parkingPrice || this.hasSubscriptionDiscount) {
      return 0;
    }
    return Number(bookingModule.parkingPrice);
  }

  get extras() {
    if (!this.booking || !this.booking.extras) {
      return;
    }
    return this.booking.extras.map(e => e.name).join(', ');
  }

  get extrasPrice() {
    if (!bookingModule.extrasPrice) {
      return 0;
    }
    return bookingModule.extrasPrice;
  }

  get gstAmount() {
    if (!this.totalPrice) {
      return 0;
    }
    return this.totalPrice * (1 / 11);
  }

  get discountPrice() {
    if (!this.discount) {
      return 0;
    }
    return (this.parkingPrice || 0) * Number(this.discount.discountRate);
  }

  get totalPrice() {
    return (this.parkingPrice || 0) - this.discountPrice + (this.extrasPrice || 0);
  }

  get vehicle() {
    if (!this.booking) {
      return;
    }
    if (this.booking.customer) {
      return this.booking.vehicle.fullName;
    } else {
      return `${this.booking.rego} - ${this.booking.colour} ${this.booking.make} ${this.booking.model}`;
    }
  }

  get isNonFieldBookingError() {
    return (
      !!this.bookingError &&
      this.bookingError.pointer.includes("non_field_error")
    );
  }

  formatPrice(price: number) {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
    }).format(price);
  }

  bookingBack() {
    this.$router.back();
  }

  async submitPromo() {
    if (!this.promoCode.trim()) {
      return;
    }
    let item;
    try {
      this.promoLoading = true;
      this.promoError = false;
      item = new PromoCode({
        code: this.promoCode.toUpperCase(),
        dropOffStart: this.booking?.startDatetime,
        dropOffEnd: this.booking?.endDatetime,
      });
      await item.save();
      this.discount = item;
      this.promoSuccess = true;
    } catch (err) {
      // Error
      this.promoSuccess = false;
      this.promoError = true;
      this.discountError = err.response.errors[0].detail ?? 'This promo code is not valid';
    } finally {
      this.promoLoading = false;
    }
  }

  async step6() {
    if (!this.booking) {
      return;
    }

    if (this.discount) {
      this.booking.promoCode = this.discount.code;
    }

    try {
      this.loading = true;
      await this.booking.save({
        with: [
          'vehicleType.id',
          'airlineOut.id',
          'airlineIn.id',
          'lot.id',
          'lotRegion.id',
          'customer.id',
          'vehicle.id',
          'extras.id',
          'createdBy.id',
        ],
      });
      this.bookingError = null;
      if (this.hasSubscriptionDiscount && !this.totalPrice) {
        bookingModule.setCompletedStep(7);
        this.$router.push({
          name: 'booking-step-8',
        });
      } else {
        bookingModule.setCompletedStep(6);
        this.$router.push({
          name: 'booking-step-7',
        });
      }
    } catch (err) {
      // Error
      this.bookingError = {
        detail: err.response.errors[0].detail,
        pointer: err.response.errors[0].source.pointer || '',
      };
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    bookingModule.setCurrentStep(6);
    bookingModule.checkStatus();
  }

  @Watch('promoSuccess')
  promoSuccessChanged(val: boolean, oldVal: boolean) {
    if (val === false) {
      this.discount = null;
    }
  }
}
